var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c("mini-header", {
        attrs: {
          title: "Tiendas",
          breadcrumbs: _vm.breadcrumbs,
          hiddenTab: true,
          dense: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _c(
                  "v-form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.filterByNameID.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm.$helpers.hasPermission(["view_branch"])
                      ? _c(
                          "v-row",
                          {
                            staticClass: "mr-5",
                            staticStyle: { "min-width": "100%" },
                            attrs: {
                              align: "center",
                              justify: "end",
                              "no-gutters": "",
                            },
                          },
                          [
                            _c(
                              "v-col",
                              { staticClass: "mr-2", attrs: { cols: "6" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    outlined: "",
                                    required: "",
                                    "single-line": "",
                                    dense: "",
                                    maxlength: "60",
                                    "persistent-hint": "",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.filter,
                                    callback: function ($$v) {
                                      _vm.filter = $$v
                                    },
                                    expression: "filter",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("v-col", { attrs: { cols: "auto" } }, [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { text: "", color: "grey-900" },
                                      on: { click: _vm.filterByNameID },
                                    },
                                    [_vm._v("Filtrar")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ml-2",
                                      attrs: {
                                        color: "grey-900",
                                        ripple: false,
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.dialogBranch = true
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { left: "" } }, [
                                        _vm._v("mdi-plus-box"),
                                      ]),
                                      _vm._v("Nueva tienda"),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "v-col",
        { staticClass: "px-0" },
        [
          !_vm.$helpers.hasPermission(["view_branch"])
            ? _c("PermissionDenied", { attrs: { isDetail: true } })
            : [
                _vm.loading || _vm.$store.state.pos.retrieveLoader
                  ? _c("VSkeleton")
                  : [
                      _c(
                        "v-col",
                        { staticClass: "px-0 pt-0", attrs: { cols: "12" } },
                        [
                          !_vm.branchesList?.length
                            ? _c("v-empty-state", {
                                attrs: {
                                  type: "branch",
                                  id: "tiendas",
                                  customClass: "mt-3",
                                  title: "No existen tiendas para mostrar",
                                  hiddenDescription: true,
                                  isFree: true,
                                },
                              })
                            : [
                                _c(
                                  "v-row",
                                  _vm._l(_vm.branchesList, function (d, index) {
                                    return _c(
                                      "v-col",
                                      {
                                        key: `${d.id}-${index}`,
                                        attrs: {
                                          cols: "4",
                                          md:
                                            _vm.$vuetify.breakpoint.width < 1200
                                              ? 3
                                              : 2,
                                        },
                                      },
                                      [
                                        _c("v-hover", {
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ hover }) {
                                                  return [
                                                    _c(
                                                      "v-card",
                                                      {
                                                        staticClass:
                                                          "px-5 pt-5 pb-1 rounded-md",
                                                        attrs: {
                                                          elevation: hover
                                                            ? 5
                                                            : 0,
                                                          flat: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.goTo(
                                                              d.branch_id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-card-text",
                                                          {
                                                            staticClass: "pa-0",
                                                          },
                                                          [
                                                            _c(
                                                              "v-row",
                                                              {
                                                                staticClass:
                                                                  "ml-n1",
                                                                attrs: {
                                                                  "no-gutters":
                                                                    "",
                                                                  align:
                                                                    "center",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mt-n2",
                                                                    attrs: {
                                                                      color:
                                                                        "grey-900",
                                                                      size: "18",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-store"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c("v-spacer"),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "body-1 grey-300--text mr-n1",
                                                                  },
                                                                  [
                                                                    d.branch_id
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "d-inline-block text-truncate",
                                                                            staticStyle:
                                                                              {
                                                                                "max-width":
                                                                                  "130px",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "ID: " +
                                                                                _vm._s(
                                                                                  d.branch_id
                                                                                )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "mt-n2 ml-n1",
                                                                attrs: {
                                                                  "three-line":
                                                                    "",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  [
                                                                    d.name
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "body-1 grey-500--text",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                d.name
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    !d.name
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "body-2 text--disabled font-italic",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Sin especificar"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                ),
                              ],
                        ],
                        2
                      ),
                    ],
              ],
        ],
        2
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            "no-click-animation": "",
            scrollable: "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogBranch,
            callback: function ($$v) {
              _vm.dialogBranch = $$v
            },
            expression: "dialogBranch",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "px-2",
                      attrs: { color: "transparent", flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Crear tienda")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-2",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogBranch = false
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { size: "24" } }, [
                                    _vm._v("mdi-close"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "py-0 px-7" },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "pt-2 pb-2",
                      attrs: { align: "center", "no-gutters": "" },
                    },
                    [
                      _c("v-col", { attrs: { cols: "4" } }, [
                        _c("img", {
                          attrs: {
                            src: require(`@/assets/empty-state/appAsset--branch-ax.svg`),
                            height: 218,
                          },
                        }),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "pr-0 pl-8" },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-center mb-4" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  attrs: { size: "24", color: "grey-700" },
                                },
                                [_vm._v("mdi-domain")]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "subtitle-2 grey-700--text font-weight-semibold",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$store.state.auth.account.name
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                "v-col",
                                { staticClass: "pr-2", attrs: { cols: "6" } },
                                [
                                  _c("v-list-item-title", [_vm._v("Nombre")]),
                                  _c("v-text-field", {
                                    attrs: {
                                      error: _vm.$v.newBranch.name.$error,
                                      outlined: "",
                                      required: "",
                                      "single-line": "",
                                      dense: "",
                                      maxlength: "100",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.$v.newBranch.name.$model,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.$v.newBranch.name,
                                          "$model",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "$v.newBranch.name.$model",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "pl-2", attrs: { cols: "6" } },
                                [
                                  _c("v-list-item-title", [_vm._v("ID")]),
                                  _c("v-text-field", {
                                    attrs: {
                                      error: _vm.$v.newBranch.branch_id.$error,
                                      outlined: "",
                                      required: "",
                                      "single-line": "",
                                      dense: "",
                                      maxlength: "64",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.$v.newBranch.branch_id.$model,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.$v.newBranch.branch_id,
                                          "$model",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression:
                                        "$v.newBranch.branch_id.$model",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogBranch = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey-900" },
                      on: { click: _vm.createBranch },
                    },
                    [_vm._v("Crear tienda")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }